import { useCallback, useRef, useState } from 'react';

const VALID_SIZES = [20, 50, 100];
const DEFAULT_SIZE = 50;

function readStored(key) {
  try {
    const n = parseInt(localStorage.getItem(`exelflow_pagesize_${key}`), 10);
    return VALID_SIZES.includes(n) ? n : DEFAULT_SIZE;
  } catch {
    return DEFAULT_SIZE;
  }
}

// Dimensione pagina di un elenco, ricordata tra una visita e l'altra (per
// elenco). Restituisce anche un ref sempre aggiornato, da usare dentro le
// funzioni di caricamento (compresi i timer di aggiornamento automatico)
// senza dover aspettare il prossimo render.
export default function usePageSize(key) {
  const [pageSize, setPageSizeState] = useState(() => readStored(key));
  const pageSizeRef = useRef(pageSize);

  const setPageSize = useCallback((size) => {
    const next = VALID_SIZES.includes(size) ? size : DEFAULT_SIZE;
    pageSizeRef.current = next;
    setPageSizeState(next);
    try { localStorage.setItem(`exelflow_pagesize_${key}`, String(next)); } catch { /* storage non disponibile */ }
  }, [key]);

  return { pageSize, pageSizeRef, setPageSize };
}
